import { P } from 'ts-pattern';
import { GuardP } from 'ts-pattern/dist/types/Pattern';

export const gt = <T>(other: T): GuardP<T, never> => P.when((val: T) => val > other);
export const gte = <T>(other: T): GuardP<T, never> => P.when((val: T) => val >= other);
export const lt = <T>(other: T): GuardP<T, never> => P.when((val: T) => val < other);
export const lte = <T>(other: T): GuardP<T, never> => P.when((val: T) => val <= other);
export const between = <T>(min: T, max: T): GuardP<T, never> => P.when((val: T) => val > min && val < max);
export const hasLen: GuardP<string | unknown[], never> = P.when((val) => val.length > 0);
